var _rect, _rect2, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDuration(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 34,
    viewBox: "0 0 33 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2.59961,
    y: 3,
    width: 28,
    height: 28,
    rx: 14,
    fill: "#00ACC1"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2.59961,
    y: 3,
    width: 28,
    height: 28,
    rx: 14,
    stroke: "#E0F7FA",
    strokeWidth: 4.66667
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_968_11222)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.9546 12.1499L23.6532 12.1504L23.6539 11.2131L21.5086 11.2115L21.2318 13.3729L22.1617 13.492L22.2534 12.7764C23.1663 13.9914 23.661 15.4614 23.6621 17.007C23.6635 18.8931 22.9303 20.6657 21.5975 21.9982C20.2659 23.3296 18.4952 24.0626 16.6108 24.0626H16.6055C14.7189 24.0612 12.9447 23.3253 11.6096 21.9905C10.2745 20.6557 9.53849 18.8817 9.53711 16.9954C9.53574 15.1093 10.269 13.3367 11.6018 12.0042C13.6014 10.0049 16.5921 9.39337 19.2209 10.4462L19.5695 9.57609C16.5918 8.38347 13.2041 9.07637 10.9389 11.3413C9.4288 12.8512 8.59805 14.8594 8.59961 16.9961C8.60117 19.1325 9.43471 21.1416 10.9466 22.6533C12.4586 24.165 14.468 24.9984 16.6048 25H16.6108C18.7455 24.9999 20.7518 24.1694 22.2603 22.6611C23.7704 21.1513 24.6012 19.1431 24.5996 17.0064C24.5983 15.2281 24.0202 13.5384 22.9546 12.1499Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5996 12.1268C13.9115 12.1268 11.7246 14.3134 11.7246 17.0012C11.7246 19.689 13.9115 21.8756 16.5996 21.8756C19.2877 21.8756 21.4746 19.689 21.4746 17.0012C21.4746 14.3134 19.2877 12.1268 16.5996 12.1268ZM18.609 17.47H16.1309V14.9921H17.0684V16.5325H18.609V17.47Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_968_11222"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(8.59961 9)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDuration);
export default __webpack_public_path__ + "static/media/duration.693b0f0b2e0219ca9d0390f192853f39.svg";
export { ForwardRef as ReactComponent };